import { v4 as uuidv4 } from 'uuid';

interface PageJSON {
  page: {
    rows: {
      columns: {
        uuid: string;
        modules: {
          uuid: string;
        }[];
      }[];
      uuid: string;
      metadata?: unknown;
    }[];
  };
}

const convertPageToRow = (pageJSON: PageJSON, savesRowName: string): string => {
  if (pageJSON.page.rows.length > 1) {
    throw new Error(
      'Components can only use one row in their design. Please revise your design before saving'
    );
  }
  if (pageJSON.page.rows[0]) {
    const row = pageJSON.page.rows[0];
    row['metadata'] = { name: savesRowName };
    row['uuid'] = uuidv4();
    if (row.columns[0]) {
      row.columns[0]['uuid'] = uuidv4();
      if (row.columns[0].modules[0]) {
        row.columns[0].modules[0]['uuid'] = uuidv4();
      }
    }
    return JSON.stringify(row);
  } else {
    throw new Error('not proper to save');
  }
};

export default convertPageToRow;
